import axios from './../../config/axios';

/**
 * 
 * @param {String} query The search string
 * @returns {Promise}
 */
function search(query) {
    return axios().get("/fleet/dimensions", {
        params: {
            search: query
        }
    });
}

export default {
    search
}